import React, { forwardRef, useImperativeHandle, useRef } from "react";
import styles from "./Markdown.module.css";
import { Scrollbars } from "react-custom-scrollbars";
import { Editor } from "@tiptap/react";
import cs from "classnames";
import { isSafari } from "@/utils";

import MarkdownEditor from "@/components/markdownEditor";

interface MdEditorProps {
  onChange?: (markdown: string, html: string, len: number) => void;
  value?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  autoFocus?: boolean;
}

const Markdown = forwardRef((props: MdEditorProps, ref) => {
  const { onChange, value, onBlur, onFocus, autoFocus } = props;
  const editorRef = useRef<{
    editor: () => Editor;
  }>(null);

  useImperativeHandle(ref, () => ({
    getEditor: () => editorRef.current?.editor(),
  }));

  return (
    <>
      <div
        className={cs(styles.mdEditorWrapper, {
          [styles.mdEditorWrapperSafari]: isSafari(),
          [styles.mdEditor]: true,
        })}
      >
        {/* @ts-ignore */}
        <Scrollbars
          className={cs(styles.mdEditorWrapper, {
            [styles.mdEditorWrapperSafari]: isSafari(),
          })}
          autoHide
          autoHeight
          autoHeightMax={500}
        >
          <MarkdownEditor
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder="请输入内容"
            autoFocus={autoFocus}
          />
        </Scrollbars>
      </div>
    </>
  );
});

Markdown.displayName = "Markdown";

export default React.memo(Markdown);
